var msInOneDay = 24 * 60 * 60 * 1000;
export function countDays(time) {
    return (Date.now() - time) / msInOneDay;
}
